import Tooltip from '@material-ui/core/Tooltip'
import grey from '@material-ui/core/colors/grey'
import FileCopyIcon from '@material-ui/icons/FileCopy'
import IconButton from 'lib/ui/IconButton'
import React, {useState} from 'react'
import styled from 'styled-components'

// How long to show the 'Copied' label after a user clicks the icon.
const copiedLabelDurationMs = 1500

export interface CopyLinkButtonProps {
  url: string
}

export default function CopyLinkButton(props: CopyLinkButtonProps) {
  const {url} = props
  const [isCopied, setIsCopied] = useState(false)

  const handleClick = () => {
    navigator.clipboard.writeText(url)
    setIsCopied(true)
    setTimeout(() => setIsCopied(false), copiedLabelDurationMs)
  }

  return (
    <Tooltip
      title={isCopied ? 'Copied' : 'Copy attendee link'}
      placement="bottom"
    >
      <Centered>
        <StyledIconButton
          aria-label="copy attendee link"
          isCopied={isCopied}
          onClick={handleClick}
        >
          <FileCopyIcon fontSize="small" />
        </StyledIconButton>
      </Centered>
    </Tooltip>
  )
}

const Centered = styled.span`
  display: flex;
  align-items: center;
`

const StyledIconButton = styled(IconButton)<{isCopied: boolean}>`
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  margin-left: ${(props) => props.theme.spacing[1]};
  color: ${(props) =>
    props.isCopied ? props.theme.colors.primary : grey[500]};
`
